export default "__VITE_ASSET__C5gXMKv5__"